import {
  isValidUrl,
  assertCharacterNotPresent,
} from 'validator/textFieldValidator';

export const validateField = (
  fieldName: string,
  dataToValidate: string | undefined,
) => {
  let validation = true;
  let validationMessage: string | undefined;
  if (typeof dataToValidate === 'undefined') {
    return { validation, validationMessage };
  }

  switch (fieldName) {
    case 'url':
      if (typeof dataToValidate !== 'string') {
        throw new Error(
          `ValidateField.ts: dataToValidate must be of type of string or undefined, got ${typeof dataToValidate} intead.`,
        );
      }
      if (dataToValidate === '') {
        return { validation, validationMessage };
      }
      validation =
        isValidUrl(dataToValidate) &&
        assertCharacterNotPresent(dataToValidate, '#');
      validationMessage = !validation
        ? 'Le format du champ est invalide'
        : undefined;
      return { validation, validationMessage };
    default:
      throw new Error('No cases match : validateField');
  }
};
